import React from 'react';
import { Redirect } from 'react-router-dom';

import LINK from 'constants/link.const';
import { useCustomPermission } from 'providers/Access.provider';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import linkTo from 'utils/links/linkTo.util';

const PermittedRoute = ({ permission, component: Component, ...rest }) => {
  const salonId = useCurrentSalonId();
  const isPermitted = useCustomPermission(permission);

  if (!isPermitted) {
    return <Redirect to={linkTo({ pattern: LINK.settingsSalon, params: { salonId }, fault: '#' })} />;
  }

  return <Component {...rest} />;
};

export default PermittedRoute;
